import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';
import focus from '@alpinejs/focus';

function announcementData() {

    return {
        open: Alpine.$persist(true).using(sessionStorage),
    };

}

window.announcementData = announcementData;

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(focus);

Alpine.start();
